module.exports = __webpack_public_path__ + "img/ico_link-area03.2c8c14f1.svg";